import { PropsWithChildren } from "react";
import { Button, Flex, Skeleton, Spinner, Text } from "@radix-ui/themes";
import { CircleAlertIcon } from "lucide-react";
import { ReloadIcon } from "@radix-ui/react-icons";

interface InteractionViewTabContentProps {
  isLoading?: boolean;
  isError?: boolean;
  refetch?: () => void;
}

export function InteractionViewTabContent({
  isLoading = false,
  isError = false,
  refetch,
  children,
}: PropsWithChildren<InteractionViewTabContentProps>) {
  return (
    <Flex flexGrow={"1"} direction={"column"} className="overflow-hidden">
      {isLoading && (
        <Flex flexGrow={"1"} p={"4"} direction={"column"} gap={"2"}>
          <Skeleton className="w-full h-[80px]" />

          <Skeleton className="w-full h-[80px]" />

          <Flex gap={"4"}>
            <Skeleton className="w-full h-[80px]" />
            <Skeleton className="w-full h-[80px]" />
            <Skeleton className="w-full h-[80px]" />
          </Flex>
        </Flex>
      )}

      {!isLoading && isError && (
        <Flex pt={"100px"} direction={"column"} gap={"1"} align={"center"}>
          <CircleAlertIcon height={"24px"} width={"24px"} />

          <Text size={"3"} weight={"medium"} color="gray" highContrast>
            An unexpected error occurred
          </Text>

          <Text
            size={"2"}
            color="gray"
            className="max-w-[440px] text-center pb-4"
          >
            Please try again later.
          </Text>

          {refetch && (
            <Button
              onClick={refetch}
              size={"2"}
              variant={"solid"}
              color="gray"
              highContrast
            >
              <ReloadIcon />
              Retry
            </Button>
          )}
        </Flex>
      )}

      {!isLoading && !isError && children}
    </Flex>
  );
}
